import DMAS from "lib/dma-lookup.json";

export default function radius(city, state) {
  const radii = {
    "San Francisco-Oakland-San Jose,CA": 10,
    "New York,NY": 10,
    "Austin,TX": 20,
    "Washington,DC (Hagerstown,MD)": 10,
    "Philadelphia,PA": 20,
    "Denver,CO": 20,
  };
  const dma = DMAS[`${city},${state}`];
  return radii[dma] || 50;
};
